// Pantalla de "medición cerrada" (handoff §6): se muestra si GET /api/config
// devuelve open=false o si el POST responde 403.
export function ClosedScreen() {
  return (
    <main className="gb-screen gb-screen--transition">
      <p className="gb-transition__kicker">Evaluación Institucional · Familias 2026</p>
      <h1 className="gb-transition__title">La medición está cerrada por ahora</h1>
      <p className="gb-transition__intro">
        En este momento no hay una ventana de evaluación abierta. El colegio avisará a las familias
        cuando vuelva a estar disponible. Gracias por tu interés en construir colegio con nosotros.
      </p>
    </main>
  );
}
